import { createFileRoute } from '@tanstack/react-router';
import { AdminSystemScreen } from '@/features/admin/AdminSystemScreen';

export const Route = createFileRoute('/_app/admin/system')({
  component: AdminSystemScreen,
});
